
import { defineComponent, onMounted, ref } from 'vue';
import {
  getApprovedRequests,
  PartnerReviewRequestResource,
} from '@/api/partnerReviewApi';
import RequestPartnerListFilter from '@/components/RequestPartnerListFilter.vue';
import PartnerRequestApprovedListItem from '@/components/PartnerRequestApprovedListItem.vue';
import { useStore } from 'vuex';
import { key } from '@/store';

export default defineComponent({
  name: 'RequestApprovedPage',
  components: { PartnerRequestApprovedListItem, RequestPartnerListFilter },
  setup() {
    const store = useStore(key);
    const approvedRequest = ref<PartnerReviewRequestResource[]>([]);
    const filterBy = ref('7d');

    const toggleSidebar = () => {
      store.commit('setSidebarState', !store.state.layout.isSidebarOpen);
    };

    function setFilter(field: string) {
      filterBy.value = field;
      getApprovedRequestsAction(field);
    }

    onMounted(() => {
      getApprovedRequestsAction(filterBy.value);
    });

    const getApprovedRequestsAction = (filter: string) => {
      getApprovedRequests(filter).then(res => {
        approvedRequest.value = res;
      });
    };

    return {
      approvedRequest,
      setFilter,
      filterBy,
      toggleSidebar,
    };
  },
});
